import type { FormConfigurationDto } from "../../types/FormConfigurationDto";
import type { FormConfigurationEntity } from "../../types/FormConfigurationEntity";

export const FormConfigurationDtoToEntity = (formConfigurationDto: FormConfigurationDto): FormConfigurationEntity => {
    const formConfiguration = JSON.parse(formConfigurationDto?.formConfiguration || "");
    return { formConfiguration, formId: formConfigurationDto.formId };
};
